import { render } from "./application-item.vue?vue&type=template&id=ab53c956&scoped=true&ts=true"
import script from "./application-item.vue?vue&type=script&lang=tsx"
export * from "./application-item.vue?vue&type=script&lang=tsx"

import "./application-item.vue?vue&type=style&index=0&id=ab53c956&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab53c956"]])

export default __exports__